module.exports = __webpack_public_path__ + "img/picnic.d81f8d95.svg";